<rask-map-tab-widget [startTab]="'search'">
    <rask-map-widget-tab
        id="search"
        [icon]="'far fa-search'"
        [index]="0"
        [open]="true"
        [tooltip]="'DESTINERINGSOMRADEN_TOOLTIP_SOK' | translate">
        <rask-dso-search></rask-dso-search>
    </rask-map-widget-tab>

    <rask-map-widget-tab
        id="edit"
        [icon]="'far fa-pencil'"
        [index]="1"
        [tooltip]="'DESTINERINGSOMRADEN_TOOLTIP_EDITERA' | translate">
        <rask-dso-edit></rask-dso-edit>
    </rask-map-widget-tab>
</rask-map-tab-widget>

<rask-dso-karta></rask-dso-karta>